/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Outlet } from "react-router-dom";
import { LayoutWrapper } from "layout/layout-wrapper";

const MinimalLayout = () => (
    <LayoutWrapper>
        <Outlet />
    </LayoutWrapper>
);

export { MinimalLayout };
